import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceProjectCleanupRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-project-cleanup',
	path: '/jira/settings/system/performance/metrics/projectCleanup',
};
